import { Box, Typography, Button } from "@mui/material";
import { setRejectModalOpen } from "../../store/job/jobSlice";
import { useDispatch } from "react-redux";
const ProofHeader = ({ proof_id, proof_data, proofLoading, onApprove, onReject }) => {
  const allRejected = proof_data?.every(item => item.sent_approved_files === 3);
  const allApproved = proof_data?.every(item => item.sent_approved_files === 2);
  const dispatch = useDispatch();
  return (
    <Box sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      mb: 0,
      minHeight: '60px',
      px: 1,
      pr: '20px'
    }}>
      {/* Logo on the left */}
      <Box sx={{ position: "absolute", left: 0 }}>
        <img
          src="https://sewrobj.us-east-1.linodeobjects.com/development/oneflow/company_logo/1/oneflow_logo.png"
          alt="Oneflow Logo"
          style={{ height: '40px', objectFit: 'contain' }}
        />
      </Box>
      {!proofLoading && (
        <Typography variant="h6" sx={{ fontWeight: 600, fontFamily: "'Inter Tight', sans-serif" }}>
          Proof Approval
        </Typography>
      )}
      {!proofLoading && (
        <Box sx={{ position: "absolute", right: "20px", display: "flex", alignItems: "center" }}>
          {allApproved ? (
            <Typography variant="subtitle1" color="success.main">
              Already Approved
            </Typography>
          ) : allRejected ? (
            <Typography variant="subtitle1" color="error.main">
              Already Rejected
            </Typography>
          ) : (
            <>
              <Button
                variant="contained"
                color="primary"
                sx={{ mr: 1 }}
                onClick={onApprove}
              >
                Approve
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={() => dispatch(setRejectModalOpen(true))}
              >
                Reject
              </Button>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ProofHeader;
